export const DECIMAL = '.';
export const GROUP = ',';
